import { render } from "./SCADANavComponent.vue?vue&type=template&id=1e3d5737&ts=true"
import script from "./SCADANavComponent.vue?vue&type=script&lang=ts"
export * from "./SCADANavComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__